var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between text-base",class:_vm.classes},[_c('span',{staticClass:"text-base"},[_vm._v(" © "+_vm._s(`${_vm.appName ==='FlipPay' ? 'Flip Pay' : 'Rello Pay'} ${new Date().getFullYear()}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }